/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import api from "_config/api";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";

export interface ValidarDocumentoRequest {
  codigo: string;
  onSuccess?: (response?: ValidarDocumentoResponse) => void;
}

export interface ValidarDocumentoResponse {
  id: string;
  caminhoArquivo: string;
  dataEmissao: string;
  horaEmissao: string;
  impressoPor: string;
  dataValidade: string;
}

interface State {
  isRequesting: boolean;
  successPayload: ValidarDocumentoResponse | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: null,
  errors: []
};

const validarDocumentoSlice = createSlice({
  name: "servicos@validarDocumento",
  initialState,
  reducers: {
    validarDocumento: (
      state,
      action: PayloadAction<ValidarDocumentoRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    validarDocumentoSuccess: (
      state,
      action: PayloadAction<ValidarDocumentoResponse>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    validarDocumentoFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    },
    clearValidacao: (state) => {
      state.successPayload = null;
      state.isRequesting = false;
      state.errors = [];
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: ValidarDocumentoRequest;
}) {
  const { codigo, onSuccess } = params.payload;
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/validacao-docs/${codigo}/validade`
    );

    yield put(validarDocumentoSuccess(response.data));
    onSuccess?.(response.data);
  } catch (error) {
    yield put(validarDocumentoFailed(formatError(error)));
  }
}

export const {
  validarDocumento,
  validarDocumentoSuccess,
  validarDocumentoFailed,
  clearValidacao
} = validarDocumentoSlice.actions;

export const saga = takeLatest(validarDocumento.type, sagaFunction);

export const { reducer } = validarDocumentoSlice;
